import { NgModule, APP_INITIALIZER, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth/services/auth.service';
import { environment } from 'src/environments/environment';
// #fake-start#
import { FakeAPIService } from './_fake/fake-api.service';
// #fake-end#
import { APP_BASE_HREF } from '@angular/common';
import { SharedModule } from "./_metronic/shared/shared.module";
import { InterceptorService } from './services/interceptor.service';
import { ServiceWorkerModule } from '@angular/service-worker';

@NgModule({
    declarations: [AppComponent],
    providers: [
        // {
        //     provide: APP_BASE_HREF,
        //     useValue: '', // Set the URL prefix here
        // },
        { 
            provide: HTTP_INTERCEPTORS, 
            useClass: InterceptorService, 
            multi: true ,
            
        },
        // {
        //     provide: APP_INITIALIZER,
        //     useFactory: appInitializer,
        //     multi: true,
        //     deps: [AuthService],
        // },
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot(),
        HttpClientModule,
        ClipboardModule,
        NgbModule,
        // #fake-start#
        // environment.isMockEnabled
        //     ? HttpClientInMemoryWebApiModule.forRoot(FakeAPIService, {
        //         passThruUnknownUrl: true,
        //         dataEncapsulation: false,
        //     })
        //     : [],
        // #fake-end#
        AppRoutingModule,
        InlineSVGModule.forRoot(),
        NgbModule,
        SharedModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: !isDevMode(),
          // Register the ServiceWorker as soon as the application is stable
          // or after 30 seconds (whichever comes first).
          registrationStrategy: 'registerWhenStable:30000'
        }),
    ]
})
export class AppModule {}
